import { useContext } from 'react';
import { FilesUploaderContext } from './FilesUploaderProvider';

export const useUploadingFiles = () => {
  const {
    uploadingFiles,
    filesCount,
    hasUploadingFiles,
    notAbortedFilesCount,
    uploadedFiles,
    invalidFiles,
    failedFiles,
    hasFailedFiles,
    hasAbortableFiles,
    invalidFilesCount,
    uploadedFilesCount,
    failedFilesCount,
    notFailedFilesCount,
    areAllFilesUploaded,
    hasNetworkErrorResumableFiles,
    hasServerErrorAutomaticResumeFile,
  } = useContext(FilesUploaderContext);

  return {
    uploadingFiles,
    filesCount,
    hasUploadingFiles,
    notAbortedFilesCount,
    uploadedFiles,
    invalidFiles,
    failedFiles,
    hasFailedFiles,
    hasAbortableFiles,
    invalidFilesCount,
    uploadedFilesCount,
    failedFilesCount,
    notFailedFilesCount,
    areAllFilesUploaded,
    hasServerErrorAutomaticResumeFile,
    hasNetworkErrorResumableFiles,
  };
};
